import Vue from 'vue'
const filters = new Vue({
    radio: null,
    buttonSelected: null,
    startDate: null,
    endDate: null,
    radiosConsolidated: []
})
export default filters